/**
 * Package subscription types enum
 * Single source of truth for all subscription package types
 */
export enum PackageType {
  MONTHLY = 'Monthly Subscription',
  YEARLY = 'Yearly Subscription',
  QUARTERLY = 'Quarterly Subscription',
  FREE = 'Free Subscription',
  BIENNIAL = 'Biennial Subscription',
}

/**
 * Package option type for dropdown components
 */
export interface PackageOption {
  label: string;
  value: string;
}

/**
 * All package options for dropdowns (full labels)
 * Use this for profile/subscription management screens
 */
export const packageOptions: PackageOption[] = [
  { label: 'Free Subscription', value: PackageType.FREE },
  { label: 'Monthly Subscription', value: PackageType.MONTHLY },
  { label: 'Quarterly Subscription', value: PackageType.QUARTERLY },
  { label: 'Yearly Subscription', value: PackageType.YEARLY },
  { label: 'Biennial Subscription', value: PackageType.BIENNIAL },
];

/**
 * Package options with short labels for compact dropdowns
 * Use this for creation forms where space is limited
 */
export const packageOptionsShort: PackageOption[] = [
  { label: 'Free', value: PackageType.FREE },
  { label: 'Monthly', value: PackageType.MONTHLY },
  { label: 'Quarterly', value: PackageType.QUARTERLY },
  { label: 'Yearly', value: PackageType.YEARLY },
  { label: 'Biennial', value: PackageType.BIENNIAL },
];

/**
 * Premium-only package options (excludes Free)
 * Use for subscription creation where Free is not applicable
 */
export const premiumPackageOptions: PackageOption[] = [
  { label: 'Monthly', value: PackageType.MONTHLY },
  { label: 'Quarterly', value: PackageType.QUARTERLY },
  { label: 'Yearly', value: PackageType.YEARLY },
  { label: 'Biennial', value: PackageType.BIENNIAL },
];

/**
 * Legacy array format for backward compatibility
 * @deprecated Use packageOptions or PackageType enum instead
 */
const Package = [
  PackageType.MONTHLY,
  PackageType.YEARLY,
  PackageType.QUARTERLY,
  PackageType.FREE,
  PackageType.BIENNIAL,
  '',
];

export default Package;
